import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { togglePopup } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { INCREASE_LIMITS_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { GT_LEVEL } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_SEND } from 'apps/auth/constants/UrlConstants';
import { toLowerCase } from 'apps/auth/helpers/utils';
import { useExtra, useTypeOfTransfer } from 'apps/auth/hooks/selectors';

const ViewPopup = ({
    isShowChangeAmountButton,
    isShowGotItButton,
    isShowDeliveryOptions,
    isShowIncreaseLimitButton,
    isShowChangePickupButton,
    defaultDecreaseAmountButtonClick,
    decreaseAmountButtonClick,
    togglePopup,
    popupRef,
    errorText,
    profile,
    messages,
    minSumProfileLimitFrom,
    deliveryMethod,
    arrowButtonText = '',
}) => {
    const { aml_gt_increase_level_link, toCountry, toCurrency } = useExtra();
    const expectedGTLevel = profile?.amlLimit?.currentLimit + 1;
    const typeOfTransfer = useTypeOfTransfer();
    const sendUriPostfix = typeOfTransfer ? `?type=${typeOfTransfer}` : '';

    const onClose = () => {
        if (popupRef) {
            popupRef.current?.close();
        } else {
            togglePopup(false);
        }
    };
    return (
        <SimplePopup text={errorText} popupRef={popupRef}>
            {isShowIncreaseLimitButton && (
                <PopupButton
                    iconName="arrow-up"
                    text={arrowButtonText}
                    href={aml_gt_increase_level_link}
                    onClick={() => {
                        if (expectedGTLevel) {
                            amplitude.getInstance().logEvent(INCREASE_LIMITS_SHOWN, { [GT_LEVEL]: expectedGTLevel });
                        }
                    }}
                />
            )}
            {isShowChangeAmountButton && (
                <PopupButton
                    dataTestId="process-link"
                    iconName="retry"
                    text={messages.changeAmount}
                    onClick={(e) => {
                        e.preventDefault();
                        if (decreaseAmountButtonClick) {
                            decreaseAmountButtonClick(minSumProfileLimitFrom);
                        } else {
                            defaultDecreaseAmountButtonClick?.(minSumProfileLimitFrom);
                        }
                        onClose();
                    }}
                />
            )}
            {isShowGotItButton && (
                <PopupButton
                    iconName="check"
                    text={messages.gotIt}
                    onClick={(e) => {
                        e.preventDefault();
                        onClose();
                    }}
                />
            )}
            {isShowDeliveryOptions && (
                <PopupButton
                    iconName="arrow-back"
                    text={messages.changeDeliveryOption}
                    href={`${AUTH_SEND}/${toLowerCase(toCountry?.code)}/delivery${sendUriPostfix}`}
                    onClick={onClose}
                />
            )}
            {isShowChangePickupButton && (
                <PopupButton
                    iconName="arrow-back"
                    text={messages.changePickupLocation}
                    href={`${AUTH_SEND}/${toLowerCase(toCountry?.code)}/${toLowerCase(toCurrency?.code)}/${deliveryMethod}${sendUriPostfix}`}
                    onClick={onClose}
                />
            )}
        </SimplePopup>
    );
};
ViewPopup.propTypes = {
    isShowChangeAmountButton: PropTypes.bool,
    isShowGotItButton: PropTypes.bool,
    isShowDeliveryOptions: PropTypes.bool,
    isShowIncreaseLimitButton: PropTypes.bool,
    isShowChangePickupButton: PropTypes.bool,
    defaultDecreaseAmountButtonClick: PropTypes.func,
    decreaseAmountButtonClick: PropTypes.func,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
    errorText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    profile: PropTypes.object,
    messages: PropTypes.object,
    arrowButtonText: PropTypes.string,
    deliveryMethod: PropTypes.string,
    minSumProfileLimitFrom: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};
export default connect(null, { togglePopup })(ViewPopup);
